import env from '@/env';
import createAuthorizedApiClient, { AuthTokenType } from '../authorized-api-client';

const membershipApiClient = createAuthorizedApiClient(
  env.api.baseUrl.membership,
  AuthTokenType.AccessToken,
);

class MembershipService {
  fetchMembers = async (
    organisationId: string,
    searchText?: string,
    pageSize?: string | number,
    pageNumber?: string | number,
  ) => {
    const response = await membershipApiClient.get(
      `organisations/${organisationId}/users?pageSize=${pageSize || 0}&pageNumber=${
        pageNumber || 0
      }&searchText=${searchText || ''}`,
    );
    return response.data;
  };

  deleteMember = async (organisationId: string, memberId: string) => {
    const response = await membershipApiClient.delete(
      `organisations/${organisationId}/users/${memberId}`,
    );
    return response.data;
  };

  getUserInfo = async () => {
    const response = await membershipApiClient.get('users/me');
    return response.data;
  };

  getUserDetails = async (userId: string, organisationId: string) => {
    const response = await membershipApiClient.get(
      `organisations/${organisationId}?userId=${userId}`,
    );
    return response.data;
  };

  getMerchantList = async (organisationId: string) => {
    const response = await membershipApiClient.get(
      `admin/organisations?includeParentDetails=true&parentOrgId=${organisationId}`,
    );
    return response.data;
  };

  udpateOrganisation = async (organisationId: string, userId: string, companyName: string) => {
    const response = await membershipApiClient.patch(
      `organisations/${organisationId}`,
      {
        orgId: organisationId,
        companyName,
        orgType: 'UNKNOWN',
      },
      {
        params: {
          userId,
        },
      },
    );
    return response.data;
  };

  updateUserInfo = async (firstName: string, lastName: string, userId: string) => {
    const response = await membershipApiClient.patch(`users/${userId}`, {
      firstName,
      lastName,
    });
    return response.data;
  };
}

const instance = new MembershipService();
export default instance;
